import {
	DialogContentText,
	DialogContent,
	Dialog,
	DialogTitle,
	MenuItem,
	Select,
	FormHelperText,
	FormControl,
	TextField,
	InputLabel,
	SelectChangeEvent,
	Button,
	DialogActions,
	Box,
} from '@mui/material';
import { FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getGpsrPlans, getGpsrProductTypes } from '../../../redux/reducers/gpsr/selectors';
import { registerGpsrRequest } from '../../../redux/reducers/gpsr/reducer';

interface IChangeSubscriptionInformationDialogProps {
	open: boolean;
	setClose: () => void;
}

export const ChangeSubscriptionInformationDialog: FC<IChangeSubscriptionInformationDialogProps> = ({
	open,
	setClose,
}) => {
	const dispatch = useDispatch();
	const gpsrPlans = useSelector(getGpsrPlans);
	const items = useSelector(getGpsrProductTypes);
	const [numberOfProductTypes, setNumberOfProductTypes] = useState<string>('0');
	const [subscriptionPlan, setSubscriptionPlan] = useState<string>('');
	const [numberOfProductTypesError, setNumberOfProductTypesError] = useState<string>('');
	const [subscriptionPlanError, setSubscriptionPlanError] = useState<string>('');

	const handleChangeNumberOfProductTypes = (e: React.ChangeEvent<HTMLInputElement>) => {
		setNumberOfProductTypes(e.target.value);
	};

	const handleChangeSubscriptionPlan = (event: SelectChangeEvent<string>) => {
		setSubscriptionPlan(event.target.value);
	};

	const handleBlurSubscriptionPlan = () => {
		if (subscriptionPlan === '') {
			setSubscriptionPlanError('Subscription Plan is required');
		}
	};

	const handleBlurNumberOfProductTypes = () => {
		if (numberOfProductTypes === '') {
			setNumberOfProductTypesError('Additional Product Types is required');
		}
	};

	const handleReset = () => {
		setNumberOfProductTypes('');
		setSubscriptionPlan('');
		setNumberOfProductTypesError('');
		setSubscriptionPlanError('');
	};

	const handleClose = () => {
		setClose();
		handleReset();
	};

	const handleSubmit = () => {
		console.log('handleSubmit', numberOfProductTypes, subscriptionPlan);
		dispatch(
			registerGpsrRequest({
				id: items?.merchant?.id ?? 0,
				newNumberOfAdditionalProducts: Number(numberOfProductTypes),
				newPlanId: gpsrPlans?.find(plan => plan.userVisibleName === subscriptionPlan)?.id ?? 0,
				numberOfAdditionalProductTypes: items?.merchant?.numberOfAdditionalProductTypes ?? 0,
				subscriptionPlanId: items?.merchant?.subscriptionPlanId ?? 0,
				// periodStart: items?.merchant?.periodStart ?? '',
				// periodEnd: items?.merchant?.periodEnd ?? '',
			}),
		);
		handleClose();
	};

	return (
		<Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
			<DialogTitle color="primary" fontWeight="bold">
				Change Subscription Information
			</DialogTitle>
			<DialogContent>
				<Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
					<TextField
						id="numberOfProductTypes"
						name="numberOfProductTypes"
						size="small"
						sx={{
							mt: '12px',
						}}
						label="Additional Product Types"
						value={numberOfProductTypes}
						onChange={handleChangeNumberOfProductTypes}
						onBlur={handleBlurNumberOfProductTypes}
						type="number"
						inputProps={{ min: 0 }}
						fullWidth
						error={!!numberOfProductTypesError}
						helperText={numberOfProductTypes && numberOfProductTypesError}
					/>

					<FormControl fullWidth sx={{ mt: '6px' }}>
						<InputLabel id="subscriptionPlanLabel">Subscription Plan</InputLabel>
						<Select
							id="subscriptionPlan"
							labelId="subscriptionPlanLabel"
							label="Subscription Plan"
							name="subscriptionPlan"
							value={subscriptionPlan}
							onChange={(event: SelectChangeEvent<string>) => handleChangeSubscriptionPlan(event)}
							onBlur={() => handleBlurSubscriptionPlan()}
							fullWidth
							size="small"
							sx={{ mt: '6px' }}
						>
							{gpsrPlans?.map?.(plan => (
								<MenuItem key={plan.id} value={plan.userVisibleName}>
									{plan.userVisibleName}
								</MenuItem>
							))}
						</Select>
						<FormHelperText>{subscriptionPlan && subscriptionPlanError}</FormHelperText>
					</FormControl>
				</Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose}>Cancel</Button>
				<Button
					onClick={handleSubmit}
					disabled={!!numberOfProductTypesError || !!subscriptionPlanError}
				>
					Submit
				</Button>
			</DialogActions>
		</Dialog>
	);
};
